<template>
  <div class="app-navbar-actions">
    <div class="nxl-header">
      <div class="header-wrapper">
        <div class="header-right ms-auto">
          <div class="d-flex align-items-center">
            <!--国际化-->
            <div class="dropdown nxl-h-item nxl-header-language d-none d-sm-flex">
              <a
                href="javascript:void(0);"
                class=""
                data-bs-toggle="dropdown"
              >
                <button v-if="!isMobile" class="border rounded-md min-h-10 px-3 ml-3">
                  <div class="flex items-center justify-center">
                    <svg data-icon-name="projectIcon" viewBox="0 0 18 18" width="18" height="18" aria-hidden="true"><path fill-rule="evenodd" d="M10.557 11.99l-1.71-2.966 1.71-3.015h3.42l1.71 3.01-1.71 2.964h-3.42zM4.023 16l-1.71-2.966 1.71-3.015h3.42l1.71 3.01L7.443 16h-3.42zm0-8.016l-1.71-2.966 1.71-3.015h3.42l1.71 3.015-1.71 2.966h-3.42z"></path></svg>
                    <span class="text-base pl-2">{{ userStorage.project.name }}</span>
                  </div>
                </button>
              </a>
              <div class="w-auto dropdown-menu  nxl-h-dropdown  min-w-[200px]">
                <!-- <div class="fixed top-4 right-4">
                    <va-button preset="secondary" @click="confirmSelect">切换项目</va-button>
                </div> -->
                <ProjectSelector 
                  :projects="projects"  
                  :title="t('tables.all_project')"
                  :selectedProject="selectedProject"
                  @select="selectParentProject"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useUserStore } from 'obst/user-store'
import { project_list } from '@/apis/project'
import obui from '@/utils/obui'

defineProps({
  isMobile: { type: Boolean, default: false },
})

import { useI18n } from 'vue-i18n'
import { ref, onMounted, onBeforeMount } from 'vue'
const { t } = useI18n()
import { computed } from 'vue'
import { useRouter } from 'vue-router'

// 用户信息
const userStorage = useUserStore()
const projects = computed(() => userStorage.projects)
const router = useRouter()

onMounted(() => {
  project_list()
  .then((res) => {
    const { data, status } = res?.data
    if (status === true) {
      if (data.length > 0) {
        userStorage.projectsSet(data)
        
        const currentProject = userStorage.project
        const hasCurrentProject = Object.keys(currentProject || {}).length > 0

        if (!hasCurrentProject) {
          // 如果没有当前项目，选择第一个
          userStorage.changeProject(data[0])
        } else {

          // data 中包含chileren 无限嵌套，所以 要先拍平
          const flatData = data.flatMap((item: any) => {
            return [item, ...(item.children || [])]
          })


          // 如果有当前项目，验证它是否在新数据中
          const project = flatData.find((item: any) => item.id === currentProject?.id)
          if (project) {
            userStorage.changeProject(project)
          } else {
            // 如果当前项目不在新数据中，切换到第一个项目
            userStorage.changeProject(data[0])
          }
        }
      }else {
        obui.error(t('user.noProject'))
        userStorage.clearProject()
        router.push('/auth/login')
        return 
      }
    }
  })
})

const selectedProject = ref(userStorage.project)

const selectParentProject = (project: any) => {
  // selectedProject.value = project
  userStorage.changeProject(project)
  window.location.reload()
}
</script>

<style scoped lang="scss">

.app-navbar-actions {
  display: flex;
  align-items: center;
  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    padding: 0;
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    svg {
      height: 20px;
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 640px) {
      margin-left: 0;
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }
}
.pass-ask-info {
  list-style-type: disc;
  margin-top: 16px;
  margin-bottom: 30px;
}
.modal-title {
  font-size: 1rem;
  font-weight: 700;
}
.modal-dialog {
  max-width: 1600px;
}
.modal-dialog.modal-sm {
  max-width: 800px;
}
.modal-footer {
  width: calc(100% + 50px);
  // margin-left: -25px;
  padding-bottom: 0;
}

.nav-avatar {
  margin-left: 1em;
}
</style>
